angular.module('env.custom.customModule.statistics', ['common.directives.inView'])

    // Below is the route config and controller for the custom view 'Customers' for Footlink company
    .config(function ($stateProvider) {

        $stateProvider.state('client.statistics', {
            url: '/statistics',
            templateUrl: 'branding/footlink/statistics/statistics.html',
            controller: 'StatisticsController',

            data: {pageTitle: 'OrderManager: Customers Overview'}
        });
    })

    .controller('StatisticsController', function StatisticsController($q,
                                                                      $log,
                                                                      $scope,
                                                                      $state,
                                                                      toastr,
                                                                      gettextCatalog,
                                                                      usersRepository,
                                                                      $timeout,
                                                                      customResourceResolver,
                                                                      $customisationConfig,
                                                                      permissions,
                                                                      uiLocalization) {

        $scope.isBusy = true;
        $scope.monthsCount = 6; //Controls dynamically the length of the period we want the stats to be gathered for
        $scope.months = [];
        $scope.propertyToSortBy = 'count';
        $scope.reverse = false;
        $scope.statsTableHeaderLabel = '';
        $scope.limit = 10; // initial value for limit

        $scope.waitingUsersOptions = {
            title: "Waiting List",
            position: {
                top: '15%',
                left: (jQuery(window).width() - 600) / 2
            },
            animation: om.config.kendoWindowDefaultOptions.animation
        };

        var orderTypes = [
            {
                text: gettextCatalog.getString("New pair"),
                value: {isSecond: false}
            },
            {
                text: gettextCatalog.getString("Second pair"),
                value: {isSecond: true}
            }
        ];
        var statsReportTypes = [
            {
                text: gettextCatalog.getString("iQubes - Company owned"),
                value: {deviceType: 'Windows', deviceId: ''}
            },
            {
                text: gettextCatalog.getString("iPads - Company owned"),
                value: {deviceType: 'IOS', deviceId: ''}
            },
            {
                text: gettextCatalog.getString("iQubes - User owned"),
                value: {deviceType: 'Windows', deviceId: 'Own'}
            },
            {
                text: gettextCatalog.getString("iPads - User owned"),
                value: {deviceType: 'IOS', deviceId: 'Own'}
            }
        ];
        var statsPeriods = [
            {
                text: gettextCatalog.getString('Quarter'),
                value: 3
            },
            {
                text: gettextCatalog.getString('Half Year'),
                value: 6
            },
            {
                text: gettextCatalog.getString('1 year'),
                value: 12
            }
        ];

        $scope.dropdownOrdersTypeOptions = {
            dataSource: orderTypes,
            dataTextField: "text",
            dataValueField: "value",
            valueTemplate: '',
            template: "<span class='k-state-default'><span>{{dataItem.text|sTranslate}}</span></span>",
            select: function (e) {
                var selectedItem = $scope.dropdownOrdersTypeOptions.dataSource[e.item.index()];
                if ($scope.orderType !== selectedItem.value) {
                    $scope.orderTypeLabel = selectedItem.text;
                    $scope.orderType = selectedItem.value;
                    $scope.isBusy = true;
                    $scope.statsByUser = null;
                    initData();
                }
            },
            dataBound: function () {
                this.list.width('auto');
            }
        };
        $scope.dropdownStatsOptions = {
            dataSource: statsReportTypes,
            dataTextField: "text",
            dataValueField: "value",
            valueTemplate: '',
            template: "<span class='k-state-default'><span>{{dataItem.text|sTranslate}}</span></span>",
            select: function (e) {
                var selectedItem = $scope.dropdownStatsOptions.dataSource[e.item.index()];
                if ($scope.statsReportType !== selectedItem.value) {
                    $scope.statsTableHeaderLabel = selectedItem.text;
                    $scope.statsReportType = selectedItem.value;
                    $scope.isBusy = true;
                    $scope.statsByUser = null;
                    initData();
                }
            },
            dataBound: function () {
                this.list.width('auto');
            }
        };
        $scope.dropdownMonthsCountOptions = {
            dataSource: statsPeriods,
            dataTextField: "text",
            dataValueField: "value",
            valueTemplate: '',
            template: "<span class='k-state-default'><span>{{dataItem.text|sTranslate}}</span></span>",
            select: function (e) {
                var selectedItem = $scope.dropdownMonthsCountOptions.dataSource[e.item.index()];
                if ($scope.monthsCount !== selectedItem.value) {
                    $scope.isBusy = true;
                    $scope.monthsCount = selectedItem.value;
                    $scope.statsByUser = null;
                    initData();
                }
            },
            dataBound: function () {
                this.list.width('auto');
            },
            index: 1
        };

        $scope.$on("$destroy", function () {
        });

        $scope.statsTableHeaderLabel = statsReportTypes[0].text;
        $scope.statsReportType = statsReportTypes[0].value;
        $scope.orderType = orderTypes[0].value;
        $scope.orderTypeLabel = orderTypes[0].text;

        $scope.loadMore = function (last, inview) {
            if (last && inview) {
                $scope.limit += 20;
            }
        };

        $scope.doPrint = function () {
            $scope.limit = 10000000;
            //A little trick to call requestAnimationFrame twice to make sure the DOM
            //has been updated to render all the TABLE rows and cells after we change the limit for it
            //Once the DOM update finishes, we raise the printing dialog
            var intermediate = function () {
                window.requestAnimationFrame(function () {
                    window.print();
                });
            };
            window.requestAnimationFrame(intermediate);
        };

        $scope.doPrintWaitingList = function () {
            if (!$scope.waitingUsersDialog || $scope.waitingUsersDialog.element.length === 0) {
                return;
            }

            var content = $scope.waitingUsersDialog.element[0].innerHTML;
            var printWindow = window.open('', 'Print', 'height=600,width=800');

            printWindow.document.write('<html><head><title>Print</title>');
            printWindow.document.write('<link rel="stylesheet" href="./customers.css" type="text/css" />');
            printWindow.document.write('</head><body>');
            printWindow.document.write(content);
            printWindow.document.write('</body></html>');

            printWindow.document.close(); // necessary for IE >= 10
            printWindow.onload = function () { // necessary if the div contain images

                printWindow.focus(); // necessary for IE >= 10
                printWindow.print();
                $timeout(printWindow.close, 0);
            };
        };

        $scope.showUsersOnWaitingList = function () {
            $scope.waitingUsersDialog.open();
            initWaitingUsersList();
        };

        $scope.customerSearch = function (item) {
            if (!$scope.customerFilter ||
                (item.userName.indexOf($scope.customerFilter) !== -1) ||
                (item.$model.customFields.DeviceId && item.$model.customFields.DeviceId.indexOf($scope.customerFilter) !== -1)) {
                return true;
            }
            return false;
        };

        $scope.getWaitingUserType = function (wUser) {
            if (!wUser) {
                return 'n/a';
            }

            if (!wUser.$model.customFields.WaitingClass || wUser.$model.customFields.WaitingClass.toString() === '') {
                return "Error. This is not a 'waiting' user.!";
            }

            return wUser.$model.customFields.WaitingClass;
        };

        initData();

        function initData() {
            $scope.months = [];
            $scope.limit = 10;
            //We want the stats to show items for the previous 6 months, excluding current month
            $scope.currMonth1StDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
            $scope.fromDate = new Date(
                $scope.currMonth1StDay.getFullYear(),
                $scope.currMonth1StDay.getMonth() - $scope.monthsCount,
                $scope.currMonth1StDay.getDate());

            //Build months array depending on the selected desired period for report
            var d = new Date($scope.fromDate.getTime());
            for (var i = 0; i < $scope.monthsCount; ++i) {
                $scope.months.push({
                    index: d.getMonth() + 1,
                    name: d.toLocaleString('default', {month: 'short', year: '2-digit'})
                });
                d.setMonth(d.getMonth() + 1);
            }

            var initDataPromise = usersRepository.search(queryForUsersSet(
                $scope.statsReportType.deviceType, $scope.statsReportType.deviceId))
                .then(function (usersSet) {
                    var getStatsPromise;
                    if (!usersSet.items || usersSet.items.length === 0) {
                        //we don't have to request orders if we have no users list to request order items for
                        getStatsPromise = $q.when({statsByUser: [], statsByMonths: [], orderItemsCount: 0});
                    } else {
                        getStatsPromise = usersRepository.getUsersStatistics(
                            getWhereQueryForOrdersSet(
                                $scope.fromDate,
                                $scope.currMonth1StDay,
                                $scope.statsReportType.deviceType,
                                $scope.orderType.isSecond),
                            _.map(usersSet.items, function (u) {
                                return u.$model.id;
                            })
                        );
                    }

                    return getStatsPromise.then(function (usersStats) {
                        //Attach representation model to each userStat record (extend with)
                        _.each(usersStats.stats,
                            function (userStat) {
                                var foundUserModel = _.find(
                                    usersSet.items,
                                    function (u) {
                                        return u.$model.name === userStat.userName;
                                    }
                                );
                                if (foundUserModel) {
                                    _.extend(userStat, foundUserModel);
                                }
                            });

                        $scope.usersCount = usersStats.stats.length;
                        $scope.statsByUser = usersStats.stats;
                        $scope.statsByMonths = usersStats.statsByMonths;
                        $scope.orderItemsCount = usersStats.orderItemsCount;
                        $scope.isBusy = false;
                    });
                })
                .catch(function (resp) {
                    initDataPromise = null;
                    if (resp && resp.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s", resp.status, resp.statusText));
                    } else {
                        toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                    }
                });

            return initDataPromise;
        }

        function initWaitingUsersList() {
            $scope.isLoadingWaitingUsers = true;
            var initWaitingListPromise = usersRepository.search(queryForUsersSet("Waiting"))
                .then(function (usersSet) {
                    $scope.waitingUsers = usersSet.items;
                    $scope.isLoadingWaitingUsers = false;
                })
                .catch(function (resp) {
                    if (resp && resp.status) {
                        toastr.error(uiLocalization.translate("Data request failed. Error %s : %s", resp.status, resp.statusText));
                    } else {
                        toastr.error(gettextCatalog.getString("Data request failed"), gettextCatalog.getString("Server is not responding"));
                    }
                });

            return initWaitingListPromise;
        }

        function queryForUsersSet(orderClass, deviceOwnership) {
            var query =
                "User.Name <> 'DownloadService' AND User.Name <> 'admin' AND User.Name <> 'LabUser' AND User.Name <> 'comlaw' AND " +
                "User.Name <> 'DelcamSupport' AND User.Name <> 'ortesi2' AND User.Name <> 'Test' AND User.Disabled = false";

            if (orderClass && orderClass.length > 0) {
                //In addition to the orders filter, filter out the customers who should not be shown for the
                //requested report type.
                //To not create a mess of zero lines as iQube customers mostly will have zero counts for iPad(IOS) reports
                switch (orderClass) {
                    case "IOS":
                        query += " AND User.Class = 'iPad'";
                        break;
                    case "Windows":
                        query += " AND User.Class NOT LIKE '%Waiting' AND User.Class LIKE 'iQube%'";
                        break;
                    case "Waiting":
                        query += " AND User.WaitingClass > ''";
                        break;
                    default:
                        break;
                }
            }
            if (deviceOwnership != null) {
                //In addition to the other filters, we would like to filter by device ownership (company owned device or user owned device)
                switch (deviceOwnership) {
                    case "Own":
                        query += " AND User.DeviceId = 'Own'";
                        break;
                    case "":
                        query += " AND User.DeviceId <> 'Own'";
                        break;
                    default:
                        break;
                }
            }

            return {
                where: query,
                orderBy: "",
                pageNumber: 0,
                rowsPerPage: 100000000
            };
        }

        function getWhereQueryForOrdersSet(from, to, orderClass, isSecondOrder) {

            function pad(number) {
                return number < 10 ? "0" + number : number;
            }

            var sixMonthsAgo = from.getFullYear() + '-' + pad(from.getMonth() + 1) + '-' + pad(from.getDate()) +
                'T' + pad(from.getHours()) + ':' + pad(from.getMinutes()) + ':' + pad(from.getSeconds());

            var currMonth1stDayString = to.getFullYear() + '-' + pad(to.getMonth() + 1) + '-' + pad(to.getDate()) +
                'T' + pad(to.getHours()) + ':' + pad(to.getMinutes()) + ':' + pad(to.getSeconds());

            var query = "CreatedBy.Name <> 'DownloadService' AND CreatedBy.Name <> 'admin' AND CreatedBy.Name <> 'LabUser' AND CreatedBy.Name <> 'comlaw' AND "
                + "CreatedBy.Name <> 'DelcamSupport' AND CreatedBy.Name <> 'ortesi2' AND CreatedBy.Name <> 'Test' AND CreatedBy.Name <> 'appletest' AND "
                + "CreatedBy.Disabled = false AND OrderItem.Deleted = false AND Customer.Deleted = false AND "
                + "OrderItem.Created >= #" + sixMonthsAgo + "# AND OrderItem.Created <= #" + currMonth1stDayString + "#";

            if (orderClass && orderClass.length > 0) {
                //Filter out orders not suitable for the requested report
                query += " AND Order.Class = '" + orderClass + "'";
            }
            //Filter out orders not suitable for the requested report
            query += " AND Order.IsSecond = " + isSecondOrder.toString();

            return query;
        }

        $scope.sortBy = function (propertyToSortBy) {
            $scope.reverse = ($scope.propertyToSortBy === propertyToSortBy) ? !$scope.reverse : false;
            $scope.propertyToSortBy = propertyToSortBy;
        };
    })

;
